<template>
    <div>
        <div class="loading" v-if="showLoadingOverlay && !suppressGlobalLoading">
            <div class="loadingBox text-center">
                <div>
                    <img :src="loadingImg">
                </div>
                <div class="mt-2">
                    Cargando
                </div>
            </div>
        </div>
        <AppSidebar/>
        <div id="app-main" class="wrapper d-flex flex-column min-vh-100 bg-light">
            <AppHeader/>
            <div class="body flex-grow-1 px-3">
                <CContainer lg>
                    <router-view/>
                </CContainer>
            </div>
            <AppFooter/>
        </div>
    </div>
</template>
<script>
import {CContainer} from '@coreui/vue'
import AppFooter from '@/components/AppFooter.vue'
import AppHeader from '@/components/AppHeader.vue'
import AppSidebar from '@/components/AppSidebar.vue'
import {mapGetters, useStore} from "vuex";

import loadingImg from '@/assets/images/loading.gif'

export default {
    name: 'DefaultLayout',
    components: {
        AppFooter,
        AppHeader,
        AppSidebar,
        CContainer,
    },
    data() {
        return {
            showLoadingOverlay: false,
            hideLoadingTimer: null,
        }
    },
    computed: {
        ...mapGetters({
            loading: 'loading',
            authInfo: 'authInfo',
            suppressGlobalLoading: 'suppressGlobalLoading',
        })
    },
    watch: {
        // Pequeña demora al ocultar para evitar parpadeo entre requests encadenados
        loading(val) {
            if (val) {
                if (this.hideLoadingTimer) {
                    clearTimeout(this.hideLoadingTimer);
                    this.hideLoadingTimer = null;
                }
                this.showLoadingOverlay = true;
            } else {
                if (this.hideLoadingTimer) clearTimeout(this.hideLoadingTimer);
                this.hideLoadingTimer = setTimeout(() => {
                    this.showLoadingOverlay = false;
                    this.hideLoadingTimer = null;
                }, 250);
            }
        }
    },
    setup() {
        const store = useStore()
        return {
            loadingImg,
        }
    },
    mounted() {
        //console.log(this.authInfo);
    },
    methods: {}
}
</script>
